export const COMPANIES_WITHOUT_EMISSION = ["Rivadavia"]